
import { IJData, ILResults } from '@/components/models';
import { defineStore } from 'pinia';

export const useGeneralStore = defineStore('general', {
  state: () => ({
    transition: "slide-left",

    jobSection: true,
    jackpotData: {} as IJData,
    lastJackpotResult: {} as ILResults,
  }),
  getters: {
  },
  actions: {
    getjackpotData(jackpotData: IJData){
      this.jackpotData = jackpotData;
    },

    getlastJackpotResult(lastJackpotResult: ILResults){
      this.lastJackpotResult = lastJackpotResult;
    }
  },
});
